import { node, number, string } from 'prop-types';
import React from 'react';

import { ABBREVIATIONS } from '../../utils/resource-abbreviations';

export default function EntityLabel({ children, id, resourceType }) {
  return (
    <>
      {children}
      <span className="text-muted ml-1 font-weight-light">
        {ABBREVIATIONS[resourceType].toUpperCase()}-{id}
      </span>
    </>
  );
}

EntityLabel.propTypes = {
  children: node,
  id: number.isRequired,
  resourceType: string.isRequired,
};

EntityLabel.defaultProps = {
  children: undefined,
};
